import type { Language } from '@seek/ca-myprofile-utils';

import translations from './.vocab';

type Key =
  | 'Looking for cover letters?...'
  | 'Add up to 10 resumés. Accepted...'
  | 'Add resumé'
  | 'Create another'
  | 'Done'
  | 'Return to profile';

export const getTranslation = (language: Language, key: Key) => {
  const messages = translations.getLoadedMessages(language);
  if (!messages) {
    translations.load(language);
    return null;
  }
  return messages[key].format();
};
